import { Component } from 'react';
import { Button } from 'edrolo-style-guide';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import styles from './styles.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import { SingleSelector } from '../../../SingleSelector';
import QuestionSolution from '../../../QuestionSolution';
import GrokSelfReflection from '../../../GrokSelfReflection';
import questionTypePropInterface from '../../questionTypePropInterface';

class SingleSelectQuestion extends Component {
  static defaultProps = {
    selectedAnswerId: null,
    shouldDisableRespondingToThisQuestion: false,
  };

  state = {
    selectedAnswerId: this.getSelectedAnswerFromResponse(this.props.response),
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.response !== this.props.response) {
      this.setState({
        selectedAnswerId: this.getSelectedAnswerFromResponse(
          nextProps.response
        ),
      });
    }
  }

  getSelectedAnswerFromResponse(response) {
    return response && response.get('select_selected_answer');
  }

  hasUnsubmittedResponse() {
    return !this.props.response && this.state.selectedAnswerId;
  }

  render() {
    const {
      question,
      response,
      onSubmit,
      onSubmitGrok,
      grokkingItemIsSaving,
      onSubmitTeacherAnswer,
      shouldDisableRespondingToThisQuestion,
      isPrint,
    } = this.props;
    const answers = question?.get('answers');

    return (
      <>
        {answers && answers.size ? (
          <SingleSelector
            disabled={!!response || shouldDisableRespondingToThisQuestion}
            answers={answers}
            correctAnswers={response && response.get('correct_answers')}
            selectedAnswerId={this.state.selectedAnswerId}
            onChange={(selectedAnswerId) => this.setState({ selectedAnswerId })}
          />
        ) : null}

        {!response ? (
          <Button
            onClick={() => {
              onSubmitTeacherAnswer
                ? onSubmitTeacherAnswer()
                : onSubmit({
                    selectedAnswerId: this.state.selectedAnswerId,
                  });
            }}
            disabled={
              !this.hasUnsubmittedResponse() ||
              shouldDisableRespondingToThisQuestion
            }
            data-test={`submit-${EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE}`}
          >
            {onSubmitTeacherAnswer ? 'View answer' : 'Save & continue'}
          </Button>
        ) : (
          <>
            {!isPrint && (
              <>
                <QuestionSolution
                  headingText="Solution"
                  questionId={question.get('id')}
                  explanation={response.getIn(['solution', 'explanation'])}
                  videoHash={response.getIn([
                    'solution',
                    'video',
                    'wistia_hashed_id',
                  ])}
                  videoThumbnailUrl={WistiaUtils.getThumbnail(
                    response.getIn(['solution', 'video'])
                  )}
                />
                <GrokSelfReflection
                  value={response.get('grokked')}
                  onChange={onSubmitGrok}
                  isSaving={grokkingItemIsSaving}
                  className={styles.selfReflection}
                />
              </>
            )}
          </>
        )}
      </>
    );
  }
}

SingleSelectQuestion.propTypes = {
  ...questionTypePropInterface,
};

export { SingleSelectQuestion };
